if (window.location.href.includes("mercancia")) {
    
    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };

    const tablaMercancia = document.getElementById("MercTransito");
    const tableBody = tablaMercancia.querySelector("tbody");
    const puedeVerReservas = tablaMercancia.dataset.puedeVerReservas === "1";

    // Función para actualizar la tabla según los filtros
    function actualizarTabla(signal, { esRefrescoSilencioso = false } = {}) {

        const filtroMerc = document.getElementById("filtroMerc").value;
        const filtroImpo = document.getElementById("filtroImpo").value;
        const filtroEstadoImpo = document.getElementById("filtroEstadoImpo").value;
        const filtroGrupMer = document.getElementById("filtroGrupoMerc").value;
        const filtroProv = document.getElementById("filtroProv").value;

        if (!esRefrescoSilencioso) {
            window.mostrarFilasEsqueleto(tableBody, 9);
        }

        const params = new URLSearchParams({
            filtroMerc,
            filtroImpo,
            filtroEstadoImpo,
            filtroGrupoMerc: filtroGrupMer,
            filtroProv,
        });
        const url = `/api/merc?${params.toString()}`;


        return fetch(url, { ...requestOptions, cache: "no-store", signal, sinCargando: true })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                tableBody.innerHTML = "";
                
                const jsonData = result;
                const imp = jsonData.result;

                imp.resultado.forEach(item => {
                    const row = document.createElement("tr");
                    row.innerHTML = `
                        <td class="td-periodo">
                            <a class="a-table" href="/detalle-importacion?id-impo=${item.id_impo}">
                                ${item.nombre_impo}
                            </a>
                        </td>
                        <td>${item.codigo}</td>
                        <td>${item.descripcion}</td>
                        <td>${item.grupo_mercancia}</td>
                        <td>${item.nombre_proveedor}</td>
                        <td class="td-num">${Number(item.cantidad).toLocaleString()}</td>
                        <td class="td-num">${Number(item.reserva).toLocaleString()}</td>
                        <td class="td-num">${Number(item.disponible).toLocaleString()}</td>
                        <td>
                            <div class="cont-acciones">
                                ${puedeVerReservas ? `
                                    <button class="btn-tabla btn-tabla-secundario btn-ver-reservas" type="button" data-id="${item.id_mercancia}" title="Ver reservas" aria-label="Ver reservas del código">
                                        <img class="svg-acciones" src="/public/build/img/icons/ojo.svg" alt="">
                                    </button>
                                ` : ''}
                                <button class="btn-tabla btn-reservar" type="button" data-id="${item.id_mercancia}" title="Reservar" aria-label="Reservar ${item.descripcion ?? ''}">
                                    <img class="svg-acciones" src="/public/build/img/icons/reservar-mas.svg" alt="">
                                </button>
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                });
                
                if(imp.num_registros === 0){
                    const row = document.createElement("tr");
                    row.classList.add("no-data"); //Asignar la clase al <tr>
                    row.innerHTML = `
                                <td colspan="9">
                                    <div class="cont-no-data">
                                        No se encontró información.
                                        <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                                    </div>
                                </td>
                    `;
                    tableBody.appendChild(row);
                }
            });
    }

    const actualizador = window.crearActualizadorApi(actualizarTabla);

    // Esperar una pausa corta antes de consultar con los nuevos filtros.
    document.getElementById("filtroMerc").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroImpo").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroEstadoImpo").addEventListener("change", actualizador.alCambiarFiltro);
    document.getElementById("filtroGrupoMerc").addEventListener("change", actualizador.alCambiarFiltro);
    document.getElementById("filtroProv").addEventListener("change", actualizador.alCambiarFiltro);

    // Limpiar filtros
    const btnLimpiarFiltros = document.getElementById("btnLimpiarFiltros");
    if (btnLimpiarFiltros) {
        btnLimpiarFiltros.addEventListener("click", () => {
            document.getElementById("filtroMerc").value = "";
            document.getElementById("filtroImpo").value = "";
            document.getElementById("filtroEstadoImpo").value = "0";
            document.getElementById("filtroGrupoMerc").value = "0";
            document.getElementById("filtroProv").value = "0";
            actualizador.alCambiarFiltro();
        });
    }

    // Carga inicial inmediata y siguientes actualizaciones cada 5 minutos.
    actualizador.iniciar();
}
